<template>
  <div>
    <div class="page-title">Interview List</div>
    <div class="page-box">
      <div class="page-box-title">
        <el-dropdown
          v-show="multipleSelection.length !== 0"
          split-button
          @command="handleCommand"
        >
          {{ multipleSelection.length }} User selected
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="c">Batch Delete</el-dropdown-item>
            <el-dropdown-item command="b">Batch Send Announcement & Email</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-show="multipleSelection.length == 0" type="primary" @click="show3 = !show3" >Filter</el-button>
        <div>
          <importExcel @importExcel="importExcel"></importExcel>
        </div>
      </div>
      <div class="search-box">
        <el-collapse-transition>
          <el-form
            label-width="180px"
            v-show="show3"
            ref="ruleForm"
            :model="formLabelAlign"
          >
            <el-form-item label="Applicant">
              <el-input v-model="formLabelAlign.likeApplicant"></el-input>
            </el-form-item>
            <el-form-item label="Stage">
              <el-select v-model="formLabelAlign.stage" placeholder="">
                <el-option
                  v-for="(item, index) in applicationStage"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Status">
              <el-select v-model="formLabelAlign.status" placeholder="">
                <el-option
                  v-for="(item, index) in applicationStatus"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="warning" @click="onSearch"
                >Search</el-button
              >
              <el-button icon="el-icon-refresh-left" @click="onReset"
                >Reset</el-button
              >
            </el-form-item>
          </el-form>
        </el-collapse-transition>
      </div>
      <el-table
        :data="application"
        @sort-change="handleSortChange"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        style="width: 100%;"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="registrationNo" label="Registration">
        </el-table-column>
        <el-table-column label="Applicant" prop="applicantName">
          <template slot-scope="{ row }">
            <span v-if="row.applicantName"
              >{{ JSON.parse(row.applicantName).en || "" }}
              {{ JSON.parse(row.applicantName).zh_tc || "" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="stage" label="Stage">
          <template slot-scope="{ row }">
            <span>{{ row.stage | applicationStage }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="Interview 1 Datetime">
          <template slot-scope="{ row }">
            <span>{{ row.interviewTime  }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="Interview 1 Location">
          <template slot-scope="{ row }">
            <span>{{ row.interviewLocation }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="Interview 2 Datetime">
          <template slot-scope="{ row }">
            <span>{{ row.interviewTime2  }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="Interview 2 Location">
          <template slot-scope="{ row }">
            <span>{{ row.interviewLocation2 }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="Report Location">
          <template slot-scope="{ row }">
            <span>{{ row.reportLocation  }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="QR Code">
          <template slot-scope="{ row }">
            <span><qrCode :codeObject="row"></qrCode></span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        layout="total, sizes, prev, pager, next"
        :page.sync="formLabelAlign._page"
        :limit.sync="formLabelAlign._limit"
        @pagination="getInterviews"
      />
      <loadingSlotDialog
        @close="close"
        :centerDialogVisible="centerDialogVisible"
      >
        <batchSendAnnouncement
          @closeCenter="closeCenter"
          :formType="formType"
          :applicationFormIds="applicationFormIds"
        ></batchSendAnnouncement>
      </loadingSlotDialog>
      <loadingSlotDialog
        @close="closeDelete"
        :centerDialogVisible="centerDeleteDialogVisible"
      >
        <img src="@/assets/images/feather-alert-circle.png" />
        <div class="dialog-text">Are you sure to delete this item ?</div>
        <el-button @click="onConfirm" type="danger">Confirm</el-button>
        <el-button @click="onCancel">Cancel</el-button>
      </loadingSlotDialog>
    </div>
  </div>
</template>

<script>
import qrCode from './components/qrCode.vue'
import { downloadFile,getFileName } from "@/utils/is-rules";
import Pagination from "@/components/Pagination";
import {
  getInterviews,
  batchExportApplicationsRequest,
  batchDeleteInterviews,
  exportRequest,
  importInterviews
} from "@/api/admin/application";
import loadingSlotDialog from "@/components/loadingSlotDialog";
import importExcel from "@/components/importExcel";
import batchSendAnnouncement from "@/components/batchSendAnnouncement";
export default {
  components: { loadingSlotDialog, Pagination, batchSendAnnouncement, qrCode, importExcel },
  props: {
    formType: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    formType: {
      handler() {
        this.getInterviews();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      applicationFormIds: [],
      centerDeleteDialogVisible: false,
      total: 0,
      show3: true,
      application: [],
      multipleSelection: [],
      centerDialogVisible: false,
      formLabelAlign: {
        likeApplicant: null,
        stage: null,
        status: null,
        _page: 1,
        _limit: 10,
      },
    };
  },
  methods: {
    importExcel(value){
       this.importInterviews(value)
    },
    importInterviews(value){
      importInterviews(value).then(()=>{
          this.$message({
            message: "Import Successfully",
            type: "success",
          });
          this.getInterviews()
      })
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = column.prop + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getInterviews();
    },
    getApplicationPagination(val){
      this.formLabelAlign._page = val.page;
      this.formLabelAlign._limit = val.limit;
      this.getInterviews();

    },
    closeCenter() {
      this.centerDialogVisible = false;
    },
    getApplicationStudentName(row) {
      let newValue = row.filter((v) => {
        return v.type == 0;
      })[0];
      return newValue;
    },
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if(key == '_page'){
          this.formLabelAlign[key] = 1
        }
        if(key == '_limit'){
          this.formLabelAlign[key] = 10
        }
      })
      this.$refs.multipleTable.clearSelection()
      this.getInterviews();
    },
    onCancel() {
      this.centerDeleteDialogVisible = false;
    },
    closeDelete() {
      this.centerDeleteDialogVisible = false;
    },
    onSearch() {
      this.getInterviews();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    close(v) {
      this.centerDialogVisible = v;
    },
    handleCommand(v) {
      if (v == "b") {
        this.applicationFormIds = this.multipleSelection.map((v) => {
          return v.applicationFormId;
        });
        this.centerDialogVisible = true;
      }
      if (v == "c") {
        this.centerDeleteDialogVisible = true;
      }
    },
    onEdit(id, type) {
      this.$router.push({ path: `/admin/application/${id}/${type}/edit` });
    },
    onView(id, type) {
      this.$router.push({ path: `/admin/application/${id}/${type}/detail` });
    },
    onConfirm() {
      this.batchDeleteInterviews();
    },
    onExport() {
      if (this.multipleSelection.length > 0) {
        this.batchExportApplicationsRequest(this.multipleSelection);
      }else if(this.userInfo.roleId !== this.roleClerkId){
        let from = {
          formType: this.formType,
          likeApplicant: this.formLabelAlign.likeApplicant,
          stage: this.formLabelAlign.stage,
          status: this.formLabelAlign.status,
          _page: 0,
          _limit: 0,
        };
         getInterviews(from).then((v) => {
          this.batchExportApplicationsRequest(v.data);
        });
      }
    },
    onExportPDF(id) {
      this.exportRequest(id);
    },
    batchExportApplicationsRequest(exports) {
      let from = [
        ...exports.map((v) => {
          return v.id;
        }),
      ];

      batchExportApplicationsRequest(from).then((v) => {
         downloadFile(v.data, getFileName(v.data));
      });
    },
    exportRequest(id) {
      exportRequest(id).then((v) => {
        downloadFile(v.data, getFileName(v.data));
      });
    },
    batchDeleteInterviews() {
      let from = [
        ...this.multipleSelection.map((v) => {
          return v.id;
        }),
      ];
      batchDeleteInterviews(from)
        .then(() => {
          this.getInterviews();
        })
        .finally(() => {
          this.centerDeleteDialogVisible = false;
        });
    },
    getInterviews() {
      let from = {
        formType: this.formType,
        likeApplicant: this.formLabelAlign.likeApplicant,
        stage: this.formLabelAlign.stage,
        status: this.formLabelAlign.status,
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getInterviews(from).then((v) => {
        this.application = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  background-color: #fff;
}
.page-box-title {
  display: flex;
  border-bottom: 1px solid #707070;
  justify-content: space-between;
  padding: 0 47px;
  padding-top: 46px;
  padding-bottom: 27px;
}
.search-box {
  padding-top: 50px;
  padding-bottom: 40px;
  padding-left: 50px;
  padding-right: 50px;
}
.el-button--primary {
  width: auto;
  background-color: #060c60;
  border-color: #060c60;
  font-size: 20px;
  font-weight: bold;
}
.dialog-text {
  font-size: 36px;
  color: #272727;
  text-align: center;
}
</style>